import type { HostTierView } from './hostTierView';

export type EntryOffer =
  /** Offer the button; the stored tier says Host Mode is allowed. */
  | { offer: true; reason: 'tier-allows' | 'cloud-host' }
  /** Do not offer it. */
  | { offer: false; reason: 'unevaluated' | 'tier-disallows' };

/**
 * Whether the shell should offer "Activate Host Mode".
 *
 * Rules from the architecture doc:
 *   - A missing detail is the UNEVALUATED state: do not offer it. The shell must
 *     not treat "we don't know yet" as "you're allowed".
 *   - A cloud host is offered entry even when the detail is missing or the tier
 *     disallows it, because the service gate exempts cloud hosts too.
 *   - Otherwise the stored tier's capability decides.
 *
 * This is only the OFFER. The service gate remains the authority once Phase 6 is
 * installed; hiding a button is not enforcement.
 */
export function resolveEntryOffer(view: HostTierView, isCloudHost: boolean): EntryOffer {
  if (isCloudHost) return { offer: true, reason: 'cloud-host' };
  if (view.tierId === null) return { offer: false, reason: 'unevaluated' };
  if (!view.hostModeAllowed) return { offer: false, reason: 'tier-disallows' };
  return { offer: true, reason: 'tier-allows' };
}
